import React from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../../lib/contact";

const WhatsAppGlyph = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 4.92A10 10 0 0 0 4.07 18.2L3 22l3.88-1.03A10 10 0 1 0 19.11 4.92Zm-7.1 15.34a8.27 8.27 0 0 1-4.21-1.15l-.3-.18-2.3.61.62-2.24-.2-.32a8.27 8.27 0 1 1 6.4 3.28Zm4.55-6.2c-.25-.12-1.47-.72-1.7-.8-.23-.09-.39-.13-.56.12-.16.24-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.38-1.72c-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.16.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.49-.41-.42-.56-.43h-.48a.92.92 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.02 2.6.13.17 1.76 2.69 4.27 3.77 1.49.64 2.07.7 2.81.59.45-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.15-1.18-.07-.1-.23-.16-.49-.28Z" />
  </svg>
);

const FloatingButtons = () => {
  return (
    <div
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 flex flex-col gap-3"
      data-testid="floating-cta"
    >
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp ile yaz"
        data-testid="floating-whatsapp-button"
        className="wa-pulse w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1DB954] grid place-items-center text-white shadow-2xl shadow-emerald-500/30 active:scale-95 transition-transform"
      >
        <WhatsAppGlyph className="w-7 h-7 sm:w-8 sm:h-8" />
      </a>
      <a
        href={`tel:${PHONE_TEL}`}
        aria-label="Telefon ile ara"
        data-testid="floating-phone-button"
        className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#0A192F] hover:bg-[#112240] grid place-items-center text-white shadow-2xl shadow-[#0A192F]/40 active:scale-95 transition-transform"
      >
        <Phone className="w-6 h-6 sm:w-7 sm:h-7" strokeWidth={2.4} />
      </a>
    </div>
  );
};

export default FloatingButtons;
